import { Component, OnInit } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from './../../../services/data/data.service';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { FuncionesMes, formatear, periodosOperativo} from './../../funciones/funcionesGenerales';
import { ExcelService } from '../../../services/excel/excel.service';

import Swal from 'sweetalert2';
import moment from 'moment';
import { MapaCalorService } from '../../../services/operative/mapa-calor/mapa-calor.service';
import { companies, Valores} from '../../../shared/catalogos';

@Component({
  selector: 'app-mapa-calor',
  templateUrl: './mapa-calor.component.html',
  styleUrl: './mapa-calor.component.css'
})
export class MapaCalorComponent {
  //---------------VARIABLES GENERALES
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + this.cookieService.get('auth_token'));
  private querySubscription: Subscription;
  private errorMessage = '<br/><br/><div> <span style="text-aling: center;font-size: 10pt;font-weight: 200;">Precione</span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 600;"> esc </span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 200;">para cerrar</span></div>';
  public colorMulti: any = ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'];
  public colorMono: any = ['#76C4D5'];
  public suffix = 'MXN';
  public miles = ',';
  public decimal = '.';

  //-------------VARIABLES OBTENCION DE PERIODOS
  private numEvaluaciones = 1;
  public Periodos = [];
  public Periodos2 = [];
  /*Titulos y subtitulos*/
  public subTitles = '';
  public subTitles2 = '';
  public subTitlesPat = '';
  /*Filtros*/
  public cadenaEvaluacion = [];
  public cadenaEvaluacion2 = [];
  public cadenaPatrimonio = [];

  //----------VARIABLES DEL TABLERO
  private catalogos = [    
    {name: 'Probabilidad', cat: []},
    {name: 'Impacto', cat: []},
    {name: 'Control', cat: []},
  ];
  private categoriasCat = [];
  private colores = [];
  private categorias = [];
  public reportes = [];
  private reportesAll = [];
  public filtroPeriodos = false;
  public catalogosLLen = [];
  public tit1 = []; //Probabilidad
  public tit2 = []; //Impacto
  public tit3 = []; //Control
  public tit4 = []; //riesgo 
  public enc1 = "";
  public enc2 = "";
  public enc3 = "";
  public enc4 = ""; 
  public valores1 = [];
  public valores2 = [];
  public mostrar1 = [];
  public mostrar2 = [];
  public tab1 = [];
  public tab2 = [];
  public num;
  public mostrarModal = [];
  public matriz = 1;
  private idInstitucion = '';

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private service: MapaCalorService,
    private exportExcel: ExcelService,
  ){
    this.idInstitucion = this.cookieService.get('idInstitucion');
    const ex = companies.find(i => i.id === this.idInstitucion);
    this.suffix = ex.suffix;
    this.startCatalogs();
  }
  private async startCatalogs(){
    const catalogos = [
      'impacto',
      'probabilidad',
      'controlval',
      'categoria',
      'color'
    ] as const;

    const data = await firstValueFrom(
      forkJoin(
        Object.fromEntries(
          catalogos.map(tipo => [
            tipo,
            this.service.getCatalogos(this.idInstitucion, tipo),
          ]),
        ),
      ),
    );
    this.catalogos[0].cat = [].concat(data['impacto']);
    this.catalogos[1].cat = [].concat(data['probabilidad']);
    this.catalogos[2].cat = [].concat(data['controlval']).sort((a,b) => b.id - a.id);
    this.categoriasCat = [].concat(data['categoria']);
    this.colores = [].concat(data['color']).map( c => c.name);
    this.getEvaluacion();
  }
  ngOnInit(): void {}
  /* Mensaje de error consultas */
  private errorMesage(err){
    var errores = ''
    for(const er of err.message){
      errores += er +'<br>'
    }
    var texto = errores + this.errorMessage;

      Swal.fire({
        html: texto,
        icon: 'error',
        showCancelButton: false,
        showConfirmButton: false,
      });
  }
  ///----------FUNCIONES OBTENCION DE PERIODOS 
  //obtencion de periodos
 //obtencion de periodos
  private getEvaluacion(){
    this.obtCategorias();
  }
  private ordenamientoDataEvaluacion() {
    const iniDate = this.reportesAll.map( i => moment(i.event_date) ).sort( (a, b) => a.diff(b))[0];
    
    const fecha = moment();
    this.Periodos = periodosOperativo.obtenerPeriodosFechas(fecha, iniDate);
    this.Periodos[this.Periodos.length-1].series[this.Periodos[this.Periodos.length-1].series.length-1].check = false;
    this.Periodos[0].series[0].check = true;
    this.Periodos2 = periodosOperativo.obtenerPeriodosFechas(fecha, iniDate);
    this.obtenerDataEvaluacion();
  }
  /* Obtención de periodos */
  private obtenerDataEvaluacion(){
    this.cadenaEvaluacion = [];
    this.cadenaEvaluacion2 = [];
    this.subTitles = "";
    this.subTitles2 = "";
    var tot=0;
    for(var i = this.Periodos.length-1; i>=0; i--){
      for(var j = this.Periodos[i].series.length-1; j>=0; j--){
        if(this.Periodos[i].series[j].check){
          this.cadenaEvaluacion.push({
            evaluacion: this.Periodos[i].series[j].periodo,
            porcentaje: '%',
            periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    for(var i = this.Periodos2.length-1; i>=0; i--){
      for(var j = this.Periodos2[i].series.length-1; j>=0; j--){
        if(this.Periodos2[i].series[j].check){
          this.cadenaEvaluacion2.push({
            evaluacion: this.Periodos2[i].series[j].periodo,
            porcentaje: '%',
            periodo: this.Periodos2[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos2[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.subTitles2 = this.cadenaEvaluacion2[0].evaluacion;
    var check = false, contador = 0;
    for(let i = 0; i < this.Periodos.length; i++){
      for(let j = 0; j < this.Periodos[i].series.length; j++){
        if(this.Periodos[i].series[j].check || check){
          this.Periodos2[i].series[j].visible = true;
          check = true;
        }else{
          this.Periodos2[i].series[j].visible = false;
        }
        if(this.Periodos2[i].series[j].visible){
          contador++;
        }
      }
      if(contador == 0){
        this.Periodos2[i].visible = false;
      }
    }
    this.selecCategoriaFilter();
  }
  /* formateo de datos */
  public escrituraPeriodo(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  //Filtro Periodo
  ///funcion para select periodo
  public cambioPeriodo(per, rango){
    if(rango == 'inicio'){
      for(const an of this.Periodos){
        for(const mes of an.series){
          if(mes.periodo === per.periodo){
            mes.check = true;
          }else{
            mes.check = false;
          }
        }
      }
      var check = false, contador = 0, selec2 = 0, posAn = 0, posMes = 0;
      for(let i = 0; i < this.Periodos.length; i++){
        for(let j = 0; j < this.Periodos[i].series.length; j++){
          if(this.Periodos[i].series[j].check || check){
            this.Periodos2[i].series[j].visible = true;
            if(!check){
              posAn = i;
              posMes = j;
            }
            check = true;
          }else{
            this.Periodos2[i].series[j].visible = false;
            this.Periodos2[i].series[j].check = false;
          }
          if(this.Periodos2[i].series[j].visible){
            contador++;
          }
          if(this.Periodos2[i].series[j].check){
            selec2++;
          }
        }
        if(contador == 0){
          this.Periodos2[i].visible = false;
        }else{
          this.Periodos2[i].visible = true;
        }
      }
      if(selec2 === 0){
        this.Periodos2[posAn].series[posMes].check = true;
      }
    }
    if(rango == 'fin'){
      for(const an of this.Periodos2){
        for(const mes of an.series){
          if(mes.periodo === per.periodo){
            mes.check = true;
          }else{
            mes.check = false;
          }
        }
      }
    }

    this.obtenerDataEvaluacion();
  }
  private obtenerDataNuevamente(){

    this.getTitulos();
    this.getData();

  }
  /* Filtros */
  public activacionFiltros(){
    this.filtroPeriodos = !this.filtroPeriodos;
    this.selecCategoriaFilter();
  }
  public selecCategoriaFilter(){
    if(this.reportesAll.length !== 0){
      let aux = [];
    
      aux = [].concat(this.reportesAll);

      if(this.filtroPeriodos){
        let aux2 = [];
        const fechaIni = moment(this.cadenaEvaluacion[0].periodo+'-01');
        const fechaFin = moment(this.cadenaEvaluacion2[0].periodo+'-01');
        for(const dat of aux){
          if(periodosOperativo.validacionPeriodo(moment(dat.fecha),fechaIni,fechaFin)){
            aux2.push(dat);
          }
        }
        aux = [].concat(aux2);
      }

      this.reportes = [].concat(aux);
      this.obtenerDataNuevamente();
    }
  }
  //-----FUNCIONES DEL TABLERO
  private getReportes(){
    this.reportes = [];
    let aux = [];
    this.service.getEventos().subscribe(response =>{
      const event = response['data'];
      var i = 0;
      for(const rep of event){
        if(rep.institution_id === this.idInstitucion){
          aux.push({
            area : Number(rep.area),
            categorias : Number(rep.category),
            evento : Number(rep.event),
            fecha : moment(rep.event_date.split('T')[0]).format("YYYY-MM-DD"),
            accion : Number(rep.action_taken),
            riesgo : Number(rep.derived_risk),
            monto : Number(rep.loss_amount),
            impacto : Number(rep.impact),
            control : Number(rep.control),
            riesgoImp : Number(rep.implicit_risk),
            porACont : Number(rep.to_control),
            agencia : Number(rep.branch_office),
            concepto : Number(rep.concept),
            detalle : rep.detail,
            fuente : Number(rep.source),
            perdida : Number(rep.loss),
            perdidaTras : Number(rep.transferred_loss),
            probabilidad : Number(rep.probability),
            riesgoImp2 : Number(rep.implicit_risk_level),
            porControl : Number(rep.control_2),
            nivelExp : Number(rep.exposure_level),
            recomRies : rep.recommendation,
            plan : rep.work_plan,
            quienReg : rep.register,
            estatusPlan : Number(rep.plan_status),
            perdida_neta : Number(rep.net_loss),
            x : Number(rep.x),
            y : Number(rep.y),
            estatusEvent: Number(rep.event_status),
            id : i,
            idReporte: rep.id,
            select: false
          });
          i++;
        }
      }
      this.reportes = [].concat(aux);
      this.reportesAll = [].concat(aux);
      this.getTitulos();
      this.getData();
      this.ordenamientoDataEvaluacion();
    }, error =>{
      this.errorMesage(error.error);
    });
  }

  private getData(){
    //Tabla superior
    const arrego1 = this.catalogosLLen.filter(cat => cat.nombre === "Probabilidad")[0].catalogo;
    const arrego2 = this.catalogosLLen.filter(cat => cat.nombre === "Impacto")[0].catalogo;
    let auxFin = [], aux = [];
    let prop1 = "Probabilidad".split(' ')[0].split('/')[0].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    let prop2 = "Impacto".split(' ')[0].split('/')[0].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    for(const suc of arrego1){
      const data = this.reportes.filter( item => item[''+prop1] === suc.id);
      for(const ar of arrego2){
        const dat = data.filter( item => item[''+prop2] === ar.id);
        aux.push({
          num: dat.length,
          inf: dat,
          sel: false
        });
      }
      auxFin.push(aux);
      aux = [];
    }
    this.valores1 = JSON.parse(JSON.stringify(auxFin));
    this.valores1[0][0]['sel'] = true;
    this.mostrar1 = this.valores1[0][3].inf;
    this.enc1 = this.tit1[3].nombre.toLowerCase();
    this.enc2 = this.tit2[0].nombre.toLowerCase();
    this.num = this.valores1[0][3].num;
    this.obtTabs(1);
    //Tabla inferior
    const arrego3 = this.catalogosLLen.filter(cat => cat.nombre === "Control")[0].catalogo;
    const arrego4 = this.tit4;
    let auxFin2 = [], aux2 = [];
    let prop3 = "porControl";
    let prop4 = "riesgoImp2";
    for(const suc of arrego4){
      const data2 = this.reportes.filter( item => item[''+prop4] === suc.codigo);
      for(const ar of arrego3){
        const dat2 = data2.filter( item => item[''+prop3] === ar.id );
        aux2.push({
          num: dat2.length,
          inf: dat2,
          sel: false
        });
      }
      auxFin2.push(aux2);
      aux2 = [];
    }
    this.valores2 = JSON.parse(JSON.stringify(auxFin2));
    this.valores2[0][0]['sel'] = true;
    this.mostrar2 = this.valores2[0][this.valores2[0].length-1].inf;
    this.enc3 = this.tit3[this.tit3.length-1].nombre + '%';
    this.enc4 = this.tit4[0].nombre.toLowerCase();
    this.obtTabs(2);
  }
  public getTitulos(){
    const dat1 = this.catalogosLLen.filter( cat => cat.nombre === "Probabilidad");
    this.tit1 = this.llenarTitulos(dat1[0].catalogo);
    const dat2 = this.catalogosLLen.filter( cat => cat.nombre === "Impacto");
    this.tit2 = this.llenarTitulos(dat2[0].catalogo);
    this.tit2 = this.tit2.reverse();
    const dat3 = this.catalogosLLen.filter( cat => cat.nombre === "Control");
    this.tit3 = this.llenarTitulos(dat3[0].catalogo, true);
    this.tit4 = Valores.getTitulosTab(this.idInstitucion);

    const dat4 = this.catalogosLLen.filter( cat => cat.nombre === "Categorías");
    this.categorias = dat4[0].catalogo;
}

  public llenarTitulos(pers, c?){
    let aux = [];
    for(let i of pers){
      aux.push({
        nombre: c ? i.id : i.name
      });
    }
    return aux;
  }

  private obtCategorias(){
    var i = 0, aux = [];
    for(const cat of this.catalogos){
      aux.push({
        nombre: cat.name,
        catalogo: cat.cat,
      });      
    }
    this.catalogosLLen = aux;

    var aux = [], auxCon = [], auxEven = [];
    for(const cat of this.categoriasCat){
      if(cat.values.length !== 0){
        for(const con of cat.values){
          if(con.values.length!==0){
            for(const even of con.values){
              auxEven.push({
                name: even.name,
                id: even.id
              });
            }
          }
          auxCon.push({
            name: con.name,
            values: auxEven,
            id: con.id
          });
          auxEven = [];
        }
      }
      aux.push({
        name: cat.name,
        id: cat.id,
        values: auxCon,
      });
      auxCon = [];
    }

    let nombre = ' Categorías';
    this.catalogosLLen.push({
      nombre: nombre.substring(1),
      catalogo: aux,
    });
    this.getReportes();
  }

  public colorSup(i, j){
    const valoresSup = Valores.getSuperiores(this.idInstitucion);
    const col = valoresSup[i][j];
    return this.colores[col];
  }
  public colorInf(i, j){
    const valoresInf = Valores.getInferiores(this.idInstitucion);
    const col = valoresInf[i][j];
    return this.colores[col];
  }
  public colorSupEx(i, j){
    const valoresSup = Valores.getSuperiores(this.idInstitucion);
    const col = valoresSup[i][j];
    const argb =  this.colores[col];
    return '00'+argb.substring(1);
  }
  public colorInfEx(i, j){
    const valoresInf = Valores.getInferiores(this.idInstitucion);
    const col = valoresInf[i][j];
    const argb =  this.colores[col];
    return '00'+argb.substring(1);
  }
  public getCate(n){
    for(let i of this.categorias){
      if(i.id == n){
        return i.name;
      }
    }
  }
  public getEvent(d){
    const cat = this.catalogosLLen.filter(c => c.nombre === 'Categorías')[0].catalogo;
    return cat.filter(cat => cat.id === d.categorias)[0].values.filter(con => con.id === d.concepto)[0].values.filter(eve => eve.id === d.evento)[0].name; 
  }
  public actTabla(i,j,t){
    if(t == 1){
      this.mostrar1 = this.valores1[i][j].inf
      this.enc1 = this.tit1[j].nombre.toLowerCase();
      this.enc2 = this.tit2[i].nombre.toLowerCase();
      this.num = this.valores1[i][j].num;
      this.matriz = 1
      this.obtTabs(t);
      this.mostrarModal = this.tab1;
    }
    if(t == 2){
      this.mostrar2 = this.valores2[i][j].inf;
      this.enc3 = this.tit3[j].nombre + '%';
      this.enc4 = this.tit4[i].nombre.toLowerCase();
      this.num = this.valores2[i][j].num;
      this.matriz = 2;
      this.obtTabs(t);
      this.mostrarModal = this.tab2;
    }
    // document.getElementById("ampliar")!.style.display = "block";
  }
  private obtTabs(t){
    if(t===1){
      var aux = [];
      for(const rep of this.mostrar1){
        if(aux.length === 0){
          aux.push({
            categorias: rep.categorias,
            concepto: rep.concepto,
            evento: rep.evento,
            num: 1
          });
        }else{
          const ex = aux.filter(r => r.categorias === rep.categorias && r.concepto === rep.concepto && r.evento === rep.evento);
          if(ex.length===0){
            aux.push({
              categorias: rep.categorias,
              concepto: rep.concepto,
              evento: rep.evento,
              num: 1
            });
          }else{
            ex[0].num++;
          }
        }
      }
      this.tab1 = JSON.parse(JSON.stringify(aux));
    }
    if(t===2){
      var aux = [];
      for(const rep of this.mostrar2){
        if(aux.length === 0){
          aux.push({
            categorias: rep.categorias,
            concepto: rep.concepto,
            evento: rep.evento,
            num: 1
          });
        }else{
          const ex = aux.filter(r => r.categorias === rep.categorias && r.concepto === rep.concepto && r.evento === rep.evento);
          if(ex.length===0){
            aux.push({
              categorias: rep.categorias,
              concepto: rep.concepto,
              evento: rep.evento,
              num: 1
            });
          }else{
            ex[0].num++;
          }
        }
      }
      this.tab2 = JSON.parse(JSON.stringify(aux));
    }
  }
  public exportarTabla(zona){
    var titulos = [], datos = [], arreglo = [];
    titulos.push(this.translate.instant('operative.mapa.enc5'));
    titulos.push(this.translate.instant('operative.mapa.enc6'));
    titulos.push(this.translate.instant('operative.mapa.enc7'));

    arreglo = zona == 1 ? this.tab1 : this.tab2;

    for(const i of arreglo){
      var aux = [];
      aux.push(this.getCate(i.categorias));
      aux.push(this.getEvent(i));
      aux.push(i.num);
      datos.push(aux);
    }

    let tit1 =  this.translate.instant('operative.mapa.enc2') + " " + this.enc2 + " | " + this.translate.instant('operative.mapa.enc1') + " " + this.enc1 + " "+ this.escrituraPeriodo(this.subTitles2);
    let tit2 =  this.translate.instant('operative.mapa.enc4') + " " + this.enc4 + " | " + this.translate.instant('operative.mapa.enc3') + " " + this.enc3 + " "+ this.escrituraPeriodo(this.subTitles2);
    let nom1 =  this.translate.instant('operative.mapa.enc2') + " " + this.enc2 + " " + this.translate.instant('operative.mapa.enc1') + " " + this.enc1 + " "+ this.escrituraPeriodo(this.subTitles2)
    let nom2 =  this.translate.instant('operative.mapa.enc4') + " " + this.enc4 + " " + this.translate.instant('operative.mapa.enc3') + " " + this.enc3 + " "+ this.escrituraPeriodo(this.subTitles2);
    let mat = this.translate.instant('operative.mapa.titulo'+this.matriz) + " "
    let tituloHoja = zona == 1 ? mat + tit1 : mat + tit2;
    let nombre = zona == 1 ? mat + nom1 : mat + nom2;
    this.exportExcel.excelOperativoMapaTab(tituloHoja,titulos,datos,nombre);
  }

  public exportarMapa(zona){
    var titulos = [], enc= [], datos = [], arreglo = [], colores = [];
    if(zona == 1){ //mapa superior
      titulos.push('');
      titulos.push(this.translate.instant('operative.mapa.enc1'));
      titulos.push('');
      titulos.push('');
      titulos.push('');
      
      enc.push(this.translate.instant('operative.mapa.enc2'))
      for(const e of this.tit1){
        enc.push(e.nombre);
      }

      var i = 0, j = 0;
      for(const r of this.valores1){
        j=0
        var aux = [], col = [];
        aux.push(this.tit2[i].nombre);
        col.push('00E0E0E0');
        for(const v of r){
          aux.push(v.num);
          col.push(this.colorSupEx(i,j))
          j++
        }
        datos.push(aux);
        colores.push(col);
        i++;
      }

    }else{
      titulos.push('');
      titulos.push(this.translate.instant('operative.mapa.enc3'));
      titulos.push('');
      titulos.push('');
      titulos.push('');
      
      enc.push(this.translate.instant('operative.mapa.enc4'))
      for(const e of this.tit3){
        enc.push(e.nombre + '%');
      }

      var i = 0, j = 0;
      for(const r of this.valores2){
        j=0
        var aux = [], col = [];
        aux.push(this.tit4[i].nombre);
        col.push('00E0E0E0');
        for(const v of r){
          aux.push(v.num);
          col.push(this.colorInfEx(i,j))
          j++
        }
        datos.push(aux);
        colores.push(col);
        i++;
      }
    }

    let tit1 =  this.translate.instant('operative.mapa.titulo1') + " " + this.escrituraPeriodo(this.subTitles2);
    let tit2 =  this.translate.instant('operative.mapa.titulo2') + " " + this.escrituraPeriodo(this.subTitles2);
    let tituloHoja = zona == 1 ? tit1 : tit2;
    this.exportExcel.excelOperativoMapaCalor(tituloHoja,titulos,enc,datos,tituloHoja,colores,zona);
  }
}
